import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashChartComponent } from './smash-chart/smash-chart.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    SmashChartComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    SmashChartComponent
  ]
})
export class SmashChartModule { }
